<template>
  <CommonPopup
    ref="refCommonPopup"
    :show-close-btn="true"
  >
    <div class="wait-pay-popup">
      <div class="wait-pay-popup-content">
        <div class="wait-pay-title">待支付订单</div>
        <div class="wait-pay-column">
          <div class="wait-pay-column-label">充电账号</div>
          <div class="wait-pay-column-value">{{ value.chargePhone }}</div>
        </div>
        <div class="wait-pay-column">
          <div class="wait-pay-column-label">服务商</div>
          <div class="wait-pay-column-value">
            {{ value.providerCompanyShortName }}
          </div>
        </div>
        <div class="wait-pay-column">
          <div class="wait-pay-column-label">充电券类型</div>
          <div class="wait-pay-column-value">
            {{ value.productAmountYuanStr }}
          </div>
        </div>
        <div class="wait-pay-column">
          <div class="wait-pay-column-label">数量</div>
          <div class="wait-pay-column-value">{{ value.buyNum }}</div>
        </div>
        <div class="wait-pay-column">
          <div class="wait-pay-column-label">支付金额</div>
          <div class="wait-pay-column-value text-orange">
            ￥{{ value.payAmountYuan }}
          </div>
        </div>
      </div>
      <div class="wait-pay-popup-btns">
        <div
          class="wait-pay-popup-btn btn-default"
          @click="handleCancel"
        >
          取消订单
        </div>
        <div
          class="wait-pay-popup-btn btn-primary"
          @click="handleConfirm"
        >
          立即支付
        </div>
      </div>
    </div>
  </CommonPopup>
</template>

<script>
import CommonPopup from './CommonPopup';

export default {
  name: 'WaitPayPopup',
  components: {
    CommonPopup
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  methods: {
    openPopup() {
      this.$refs.refCommonPopup.openPopup();
      this.$emit('open');
    },
    closePopup() {
      this.$refs.refCommonPopup.closePopup();
      this.$emit('close');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.wait-pay-popup {
  background: #ffffff;
  border-radius: 20px;
  width: 600px;
  height: 616px;
  box-sizing: border-box;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .wait-pay-popup-content {
    margin-bottom: 48px;
    width: 100%;

    .wait-pay-title {
      font-size: 32px;
      color: #383838;
      text-align: center;
      font-weight: bold;
      line-height: 45px;
      margin-bottom: 48px;
    }
    .wait-pay-column {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;

      .wait-pay-column-label {
        font-size: 32px;
        color: #999999;
        font-weight: 400;
        line-height: 45px;
      }
      .wait-pay-column-value {
        font-size: 32px;
        color: #383838;
        text-align: right;
        font-weight: 400;
        line-height: 45px;
      }
      &:last-child {
        margin-bottom: unset;
      }
    }
  }
  .wait-pay-popup-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .wait-pay-popup-btn {
      width: 252px;
      height: 90px;
      border-radius: 20px;
      font-size: 32px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;

      &.btn-default {
        border: 1px solid rgba(200, 200, 200, 1);
        background: #ffffff;
        color: #383838;
      }
      &.btn-primary {
        background: #fe7256;
        color: #ffffff;
      }
    }
  }
  .text-orange {
    color: #ff722c !important;
  }
}
</style>
